import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { House, Engine, FileText, EnvelopeSimple, SignOut } from "@phosphor-icons/react";

const navItems = [
  { to: "/dashboard", label: "Επισκόπηση", icon: House, end: true, testid: "dash-nav-overview" },
  { to: "/dashboard/bikes", label: "Μηχανές", icon: Engine, testid: "dash-nav-bikes" },
  { to: "/dashboard/content", label: "Περιεχόμενο", icon: FileText, testid: "dash-nav-content" },
  { to: "/dashboard/bookings", label: "Κρατήσεις", icon: EnvelopeSimple, testid: "dash-nav-bookings" },
];

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/dashboard/login");
  };

  return (
    <div data-testid="dashboard-layout" className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-[260px_1fr] min-h-screen">
        <aside className="border-r border-white/10 bg-[#0E0E0E] p-6 flex flex-col">
          <Link to="/" data-testid="dash-back-to-site" className="flex items-center gap-2 mb-10">
            <img src="/logo.png" alt="Moto Petsas GP" className="h-10 w-auto" />
          </Link>

          <p className="text-overline mb-3">Admin</p>
          <nav className="flex flex-col gap-1">
            {navItems.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 text-sm font-bold uppercase tracking-wider transition-colors ${
                    isActive
                      ? "bg-[#E50000] text-white"
                      : "text-white/60 hover:text-white hover:bg-white/5"
                  }`
                }
              >
                <it.icon size={18} weight="bold" />
                {it.label}
              </NavLink>
            ))}
          </nav>

          <div className="mt-auto pt-6 border-t border-white/10">
            <p className="text-xs text-white/40 mb-1">Συνδεδεμένος ως</p>
            <p className="text-sm font-mono truncate">{user?.email}</p>
            <button
              onClick={onLogout}
              data-testid="dash-logout-btn"
              className="mt-4 w-full flex items-center justify-center gap-2 border border-white/15 px-4 py-2 text-xs font-bold uppercase tracking-wider hover:border-[#E50000] hover:text-[#E50000] transition-colors"
            >
              <SignOut size={14} weight="bold" /> Αποσύνδεση
            </button>
          </div>
        </aside>

        <main className="p-6 md:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
